import React from 'react'
import { EditAccountInfo } from '../presentation/EditAccountInfo'
import { Footer } from '../presentation/Footer'
import { Header } from '../presentation/Header'

export const AccountInfo = () => {
  return (
    <div>
      <Header />
      <EditAccountInfo />
      <Footer />
    </div>
  )
}